import { Link } from 'react-router-dom'
import { ArrowRight, Sparkles } from 'lucide-react'
import { ROUTES } from '@/constants'
import { AIIntroGenerator } from '@/components/ai'

export function Home() {
  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <section className="relative flex min-h-[calc(100vh-4rem)] items-center justify-center bg-gradient-to-br from-primary/10 via-background to-secondary/20">
        <div className="container mx-auto px-4 text-center sm:px-6 lg:px-8">
          <h1 className="mb-4 text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl">
            <span className="text-primary">Hello, I'm</span>
            <br />
            <span className="text-foreground">Your Name</span>
          </h1>
          <p className="mx-auto mb-8 max-w-2xl text-lg text-muted-foreground sm:text-xl">
            Web Developer / AI Enthusiast
          </p>
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to={ROUTES.PROJECTS}
              className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
            >
              View Projects
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to={ROUTES.CONTACT}
              className="inline-flex items-center gap-2 rounded-lg border border-border bg-background px-6 py-3 text-sm font-medium text-foreground transition-colors hover:bg-accent"
            >
              Contact Me
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 sm:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="mb-8 text-center text-3xl font-bold">About Me</h2>
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-lg text-muted-foreground">
              Web開発者として、モダンな技術スタックを用いたアプリケーション開発に情熱を持っています。
              React、TypeScript、クラウドサービスを活用し、ユーザー体験を最優先にしたプロダクト開発を行っています。
            </p>
          </div>
        </div>
      </section>

      {/* AI Demo Section */}
      <section className="bg-secondary/30 py-16 sm:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 text-center">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2">
              <Sparkles className="h-4 w-4 text-primary" />
              <span className="text-sm font-medium text-primary">AI Powered</span>
            </div>
            <h2 className="text-3xl font-bold">AI 機能デモ</h2>
            <p className="mt-2 text-muted-foreground">
              Cloudflare Workers AIを活用した自動生成機能をお試しください
            </p>
          </div>
          <div className="mx-auto max-w-2xl">
            <AIIntroGenerator />
          </div>
        </div>
      </section>
    </div>
  )
}
